import React, { useState, useEffect, useCallback } from "react";
import { Link } from "react-router-dom";
// import axios from "axios";
import {
  Container,
  Row,
  Col,
  Button,
  Card,
  CardBody,
  Table,
  UncontrolledTooltip,
  Spinner,
  Pagination,
  PaginationItem,
  PaginationLink,
  FormGroup,
  Modal,
} from "reactstrap";

import PerfectScrollbar from "react-perfect-scrollbar";
import "react-perfect-scrollbar/dist/css/styles.css";

// actions
import { resetGroups, getGroups, deleteGroup } from "../../store/groups/actions";

import { useDispatch, useSelector } from "react-redux";

//i18n
import { withTranslation } from "react-i18next";

import { isArray } from "../../Libs/CustomMethods/customMethods";

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";

// Toast
import toastr from "toastr";
import "toastr/build/toastr.min.css";

// availity-reactstrap-validation
import { AvForm, AvField } from "availity-reactstrap-validation";
import { renderPagination } from "../../Libs/CrudUtils/crudUtils";

const Groups = ({ t }) => {
  const dispatch = useDispatch();

  const qtdDefault = 7;

  const {
    dataGroup,
    loadingGroup,
    loadingDeleteGroup,
    errorGroup,
    successDeleteGroup,
    idGroupDelete,
  } = useSelector((state) => state.Group);

  const [page, setPage] = useState(1);
  const [groupId, setGroupId] = useState("");
  const [groupName, setGroupName] = useState("");

  const [notFound, setNotFound] = useState(false);

  const [name, setName] = useState("");

  const [nameF, setNameF] = useState("");

  const [modal, setModal] = useState(false);

  const handleFilter = () => {
    setPage(1);
    dispatch(getGroups(1, qtdDefault, name));
  };

  const handlePage = (value) => {
    setPage(value);
    dispatch(getGroups(value, qtdDefault, name));
  };

  const handlePreviousPage = () => {
    if (page > 1) {
      handlePage(page - 1);
    }
  };

  const handleNextPage = () => {
    if (dataGroup && dataGroup.paging) {
      if (page < dataGroup.paging.count) {
        handlePage(page + 1);
      }
    }
  };

  const toggleModal = useCallback(() => {
    setModal(!modal);
  }, [modal]);

  const handleDelete = () => {
    if (groupId) {
      dispatch(deleteGroup(groupId));
    }
  };

  const showToast = (type, message) => {
    toastr[type](message);
  };

  toastr.options = {
    closeButton: false,
    debug: false,
    newestOnTop: false,
    progressBar: true,
    positionClass: "toast-top-right",
    preventDuplicates: true,
    onclick: null,
    showDuration: "200",
    hideDuration: "200",
    timeOut: "2000",
    extendedTimeOut: "2000",
    showEasing: "swing",
    hideEasing: "linear",
    showMethod: "fadeIn",
    hideMethod: "fadeOut",
  };

  useEffect(() => {
    if (isArray(errorGroup) && errorGroup?.length > 0) {
      errorGroup.map(
        (error) =>
          error.value !== "not found" && showToast("error", t(error.value))
      );
      dispatch(resetGroups());
    } else {
      if (errorGroup) {
        showToast("error", t(errorGroup));
        dispatch(resetGroups());
      }
    }
  }, [dispatch, errorGroup, t]);

  useEffect(() => {
    if (successDeleteGroup) {
      showToast("success", t("Group deleted"));
      toggleModal();
      dispatch(resetGroups());
      dispatch(getGroups());
    }
  }, [dispatch, toggleModal, successDeleteGroup, t]);

  useEffect(() => {
    if (dataGroup !== null) {
      setNotFound(false);
    } else {
      setNotFound(true);
    }
  }, [dataGroup]);

  useEffect(() => {
    handleFilter();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs
            mainPath="/dashboard"
            path="/groups"
            title={t("Dashboard")}
            breadcrumbItem={t("Groups")}
          />
          <Row>
            <Col xs="12">
              <Card>
                <CardBody className="card-height">
                  <AvForm onValidSubmit={handleFilter}>
                    <Row>
                      <Col xs="12" md="auto" className="mb-3">
                        <FormGroup>
                          <AvField
                            onChange={(e) => setNameF(e.target.value)}
                            label={t("Name")}
                            id="name"
                            name="name"
                            type="text"
                            className="form-control"
                            placeholder={t("Name") + "..."}
                            value={name}
                            validate={{
                              minLength: {
                                value: 3,
                                errorMessage: t("Invalid field"),
                              },
                              maxLength: {
                                value: 45,
                                errorMessage: t("Invalid field"),
                              },
                            }}
                          />
                        </FormGroup>
                      </Col>
                      <Col
                        xs="12"
                        md="auto"
                        className="mb-3"
                        style={{ marginTop: "1.7rem" }}
                      >
                        <Button
                          type="submit"
                          color="primary"
                          className="waves-effect waves-light w-100 mb-3 mr-3"
                          onClick={() => {
                            setName(nameF);
                          }}
                        >
                          <i className="mdi mdi-feature-search-outline mr-1"></i>
                          {t("Search")}
                        </Button>
                      </Col>
                      <Col
                        xs="12"
                        md="auto"
                        className="mb-3 ml-auto"
                        style={{ marginTop: "1.7rem" }}
                      >
                        <div className="text-sm-right mb-3" id="new-group">
                          <Link to="/group">
                            <Button
                              type="button"
                              color="success"
                              className={"waves-effect waves-light w-100 mr-2 "}
                            >
                              <i className="mdi mdi-plus mr-1"></i>
                              {t("Add Group")}
                            </Button>
                          </Link>
                        </div>
                      </Col>
                    </Row>
                  </AvForm>

                  <div className="table-responsive">
                    <PerfectScrollbar>
                      <Table className="table table-centered table-nowrap">
                        <thead className="thead-light">
                          <tr>
                            <th>
                              <span className="ml-2">{"#"}</span>
                            </th>
                            <th>{t("Name")}</th>
                            <th>{t("Nº of Agents")}</th>
                            <th>{t("Nº of Managers")}</th>
                            <th>{t("Action")}</th>
                          </tr>
                        </thead>
                        <tbody>
                          {loadingGroup ? (
                            <tr>
                              <td colSpan="20" align="center">
                                <Spinner
                                  size="sm"
                                  animation="border"
                                  style={{
                                    marginTop: "40px",
                                    height: "50px",
                                    width: "50px",
                                  }}
                                />
                              </td>
                            </tr>
                          ) : notFound ? (
                            <tr>
                              <td colSpan="20" align="center">
                                {t("Click search to show the records")}
                              </td>
                            </tr>
                          ) : dataGroup &&
                            dataGroup.groups &&
                            dataGroup.groups.length > 0 ? (
                            dataGroup.groups.map((group, key) => (
                              <tr key={key}>
                                <td className="pl-4">{key + 1}</td>
                                <td className="column-text-overflow-10">
                                  {group.name}
                                </td>
                                <td>{group?.agent?.length}</td>
                                <td>{group?.manager?.length}</td>
                                <td className="pl-0">
                                  <Link
                                    to={`/group/${groupId}`}
                                    className="text-primary text-center"
                                    id="edit"
                                  >
                                    <i
                                      className="mdi mdi-pencil font-size-18 px-2"
                                      id="edittooltip"
                                      onMouseUp={() => {
                                        setGroupId(group.id);
                                        setGroupName(group.name);
                                      }}
                                    >
                                      <UncontrolledTooltip
                                        placement="auto"
                                        target="edittooltip"
                                      >
                                        {t("Edit")}
                                      </UncontrolledTooltip>
                                    </i>
                                  </Link>
                                  <span style={{ cursor: "pointer" }}>
                                    <i
                                      className="mdi mdi-window-close text-danger font-size-18 px-2"
                                      id="deletetooltip"
                                      onMouseUp={() => {
                                        setGroupId(group.id);
                                        setGroupName(group.name);
                                      }}
                                      onClick={toggleModal}
                                    >
                                      <UncontrolledTooltip
                                        placement="auto"
                                        target="deletetooltip"
                                      >
                                        {t("Delete")}
                                      </UncontrolledTooltip>
                                    </i>
                                  </span>
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan="20" align="center">
                                {t("No matching records found")}
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </Table>
                      <Modal isOpen={modal}>
                        <div className="modal-body">
                          <h5>
                            {t("Do you want delete") + " " + groupName + " ?"}
                          </h5>
                        </div>
                        <div className="modal-footer">
                          <button
                            type="button"
                            onClick={toggleModal}
                            className="btn btn-danger waves-effect"
                            data-dismiss="modal"
                            style={{ backgroundColor: "#f14646" }}
                          >
                            {t("No")}
                          </button>

                          {loadingDeleteGroup ? (
                            <button
                              type="button"
                              className="btn btn-secondary waves-effect waves-light"
                            >
                              <Spinner size="sm" animation="border" />
                            </button>
                          ) : (
                            <button
                              type="button"
                              className="btn btn-secondary waves-effect waves-light"
                              onClick={() => {
                                handleDelete();
                              }}
                            >
                              {t("Yes")}
                            </button>
                          )}
                        </div>
                      </Modal>
                    </PerfectScrollbar>
                  </div>
                  {renderPagination(
                    page,
                    dataGroup?.paging,
                    handlePreviousPage,
                    handlePage,
                    handleNextPage
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default withTranslation()(Groups);
